import { AppointmentCheckupStatus } from 'constants/appointmentCheckupStatus';
import { AppointmentCheckupStatus as AppointmentCheckupStatusEnum } from 'enums';
import { renderDate } from 'utils';
import { Status } from './components/Status/Status';
import { Badge } from '@welbe/design-system';

const setPhysicalCheckupAppointmentStatus = (
	fisicalCheckupAppointmentStatus: any,
) => {
	if (!fisicalCheckupAppointmentStatus) return '';
	return AppointmentCheckupStatus[
		fisicalCheckupAppointmentStatus as AppointmentCheckupStatusEnum
	];
};

const setLabCheckupAppointmentStatus = (labCheckupAppointmentStatus: any) => {
	if (!labCheckupAppointmentStatus) return '';
	return AppointmentCheckupStatus[
		labCheckupAppointmentStatus as AppointmentCheckupStatusEnum
	];
};

type EmployeeNameProps = {
	name: string;
	mergeStatus: string;
};

const EmployeeName = ({ name, mergeStatus }: EmployeeNameProps) => {
	if (mergeStatus === 'inProgress') {
		return (
			<span>
				{name}{' '}
				<Badge size="xs" colorPalette="yellow" variant="solid">
					Fusionando expedientes
				</Badge>
			</span>
		);
	}
	return <span>{name}</span>;
};

export const formattedRows = (data: any) => {
	return (
		data?.map((employee: any) => ({
			id: employee.id,
			name: (
				<EmployeeName
					key={employee.name}
					name={employee.name}
					mergeStatus={employee.employeeMergedStatus}
				/>
			),
			companyBadgeNumber: employee.companyBadgeNumber,
			branchOffice: employee.branchOfficeName,
			status: <Status key={employee.status} status={employee.status} />,
			nationalIdentity: employee.nationalIdentity,
			sector: employee.sector,
			position: employee.position,
			shift: employee.shift,
			hasEmployeeMerged: employee.hasEmployeeMerged,
			hiringDate: renderDate(employee.hiringDate),
			birthDate: renderDate(employee.birthDate),
			gender: employee.gender,
			schooling: employee.schooling,
			phone: employee.phone,
			alternativeEmail: employee.alternativeEmail,
			insuranceName: employee.insuranceName,
			physicalCheckupAppointmentStatus: setPhysicalCheckupAppointmentStatus(
				employee.fisicalCheckupAppointmentStatus,
			),
			labCheckupAppointmentStatus: setLabCheckupAppointmentStatus(
				employee.labCheckupAppointmentStatus,
			),
			dismissalDate: renderDate(employee.dismissalDate),
		})) ?? []
	);
};
